// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"styles_flexWrapper__XLwRe","cardTitle":"styles_cardTitle__E97Xo","trackingTitle":"styles_trackingTitle__YkBJ1"};